import * as Sentry from '@sentry/react';
import { EnvConfig } from './utils/env-config';

if (EnvConfig.SENTRY_ENVIRONMENT !== 'local') {
  Sentry.init({
    dsn: 'https://de76592875fa8d4702426e14f43f5acf@o4509831492403200.ingest.de.sentry.io/4509848259002448',
    environment: EnvConfig.SENTRY_ENVIRONMENT,

    // Adds request headers and IP for users
    sendDefaultPii: true,

    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        networkDetailAllowUrls: [
          window.location.origin,
          'starapi.inretrn.com',
          'returns.easycom.com',
          'returns.inretrn.com',
        ],
      }),
    ],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // Enable logs to be sent to Sentry
    enableLogs: true,
  });
}
